import {
  BaseQueryFn,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/dist/query/react';

import { StorageKeysEnum } from '@/enum/storageKeys.enum';

import { API_BASE_URL, TENANT_CODE } from '@/utils/constants';
import { getStorageItem, removeStorageItem } from '@/utils/localStorage';
import { logSentryMessage } from '@/utils/sentry/index';
import { HandledSentryErrorType } from '@/utils/sentry/sentry.types';

export const prepareHeaders = (headers: Headers) => {
  const jwt = getStorageItem<string>(StorageKeysEnum.jwt);

  if (jwt) {
    headers.set('authorization', `Bearer ${jwt}`);
  }
  if (TENANT_CODE) {
    headers.set('X-TENANT-ID', TENANT_CODE);
  }
  return headers;
};

const baseQuery = fetchBaseQuery({ baseUrl: API_BASE_URL, prepareHeaders });
export const baseQueryClient: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);

  if (result.error) {
    const error = result.error as any;

    if (error?.status === 401 || error.meta?.response?.status === 401) {
      removeStorageItem(StorageKeysEnum.jwt); // remove access token
      window.location.reload();
      return Promise.reject({
        message: 'Token expired',
      });
    }

    if (error?.status === 400) {
      return Promise.reject({
        message: error?.data?.message || 'Something went wrong',
      });
    }

    logSentryMessage(HandledSentryErrorType.UNEXPECTED_API_RESPONSE, error);

    return Promise.reject({
      message: 'Something went wrong',
    });
  }

  return result;
};
